import type { L } from '../types/i18n'

export interface Testimonial {
  name: string
  rating: number
  service?: L
  quote: L
}

export const testimonials: Testimonial[] = [
  {
    name: 'Shelly B.',
    rating: 5,
    service: {
      en: 'Alternator replacement',
      es: 'Cambio de alternador',
    },
    quote: {
      en: 'Excellent service from start to finish. They diagnosed my alternator issue quickly, explained everything clearly, and had my vehicle back on the road sooner than I expected. The pricing was fair, and the staff was professional and courteous. Highly recommend them.',
      es: 'Excelente servicio de principio a fin. Diagnosticaron el problema de mi alternador rápidamente, me explicaron todo con claridad y tuvieron mi vehículo de vuelta en la carretera antes de lo que esperaba. El precio fue justo y el personal fue profesional y amable. Los recomiendo mucho.',
    },
  },
  {
    name: 'Am',
    rating: 5,
    service: { en: 'General repair', es: 'Reparación general' },
    quote: {
      en: "A&J Auto Repair is hands down one of the best mechanic repair place I've been to. The team is honest, professional, and really takes the time to explain what's going on with your car without trying to upsell you on things you don't need. They work quickly, do high-quality repairs, and you can tell they actually care about getting you safely back on the road.",
      es: 'A&J Auto Repair es sin duda uno de los mejores lugares de reparación de autos en los que he estado. El equipo es honesto, profesional y realmente se toma el tiempo para explicar qué está pasando con tu auto sin intentar venderte cosas que no necesitas. Trabajan rápido, hacen reparaciones de alta calidad y se nota que de verdad les importa ponerte seguro de regreso en la carretera.',
    },
  },
  {
    name: 'tamar wilson',
    rating: 5,
    service: { en: 'Specialty repair', es: 'Reparación especializada' },
    quote: {
      en: 'Called up 15 shops none of them would do the job or didn’t know how and they found them and they did it no problem and fast, real cool dudes got the job done extremely fast and was upfront abt the price 1000% would recommend to others',
      es: 'Llamé a 15 talleres y ninguno quería hacer el trabajo o no sabía cómo, y ellos lo resolvieron sin problema y rápido. Muy buena onda, terminaron el trabajo extremadamente rápido y fueron claros con el precio. Los recomiendo 1000%.',
    },
  },
  {
    name: 'ashley',
    rating: 5,
    quote: {
      en: 'They are the best auto repair i ever been at, and the chubby guy at the front is funny as hell, this the only place i go',
      es: 'Es el mejor taller de reparación en el que he estado, y el señor del mostrador es muy divertido. Es el único lugar al que voy.',
    },
  },
]
